import statusCodes from 'http-status-codes';
import { redirectToLogin } from '../../helpers';

export default function userError(error) {
  if (
    error.status === statusCodes.UNAUTHORIZED
    || error.status === statusCodes.FORBIDDEN
  ) {
    redirectToLogin();
    return true;
  }
  return false;
}
